import { RadioBullet } from 'components/RadioGroup/RadioBullet'
import Styles from './CaptionTab.module.scss'
import { LineSkeleton } from 'components/Skeleton/LineSkeleton'

const CaptionOptionStub = ({ position }: { position: number }) => (
  <div className={Styles.captionOptionStub} aria-label="Loading caption...">
    <div className={Styles.radioButton}>
      <RadioBullet size={20} isDisabled />
    </div>
    <div className={Styles.optionRow}>
      <div className={Styles.inputLabel}>Option {position}</div>
    </div>
    <div className={Styles.captionOptionStubInput}>
      <LineSkeleton className={Styles.captionOptionStubShimmer} />
    </div>
  </div>
)

export const CaptionsLoadingState = () => (
  <div className={Styles.captionOptions}>
    <CaptionOptionStub position={1} />
    <CaptionOptionStub position={2} />
    <CaptionOptionStub position={3} />
    <CaptionOptionStub position={4} />
    <CaptionOptionStub position={5} />
  </div>
)
